module.exports = __webpack_public_path__ + "img/car_clio_hb.99f3f6a7.jpg";